import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { BEM, renderClassName } from '@feedfm/feed-util';
import './AddToStationButton.scss';

const bem = new BEM( 'echo-chamber' );
interface AddToStationButtonProps {
  onAddToStation: () => void;
}

export const AddToStationButton: React.FC<AddToStationButtonProps> = ( { onAddToStation } ) => {
  const handleAddToStation = () => {
    onAddToStation();
  };

  return (
    <button className={ renderClassName( bem.el( 'add-to-station-button' ) ) } onClick={ handleAddToStation }>
      <FontAwesomeIcon icon={ faPlus } />
    </button>
  );
};
